import axios from 'api';

// /api/super/settings/ — runtime config store. `value` is a JSON field
// (number, string, bool, array, or nested object).

export const getSettings = (filtersData, signal) => {
  const { page_size, page, search } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  return axios.get(`/api/super/settings/?${params.toString()}`, { signal });
};

export const getSettingByKey = (key) => {
  return axios.get(`/api/super/settings/${encodeURIComponent(key)}/`);
};

// Body: { key, value, description? }
export const createSetting = (params) => {
  return axios.post(`/api/super/settings/`, params);
};

// Body: { value?, description? }
export const updateSetting = ({ key, ...body }) => {
  return axios.patch(`/api/super/settings/${encodeURIComponent(key)}/`, body);
};

export const deleteSetting = (key) => {
  return axios.delete(`/api/super/settings/${encodeURIComponent(key)}/`);
};

export const invalidateSettingCache = (key) => {
  return axios.post(`/api/super/settings/${encodeURIComponent(key)}/invalidate-cache/`);
};
